// swiper実行
// --- 最新のswiper v11ではループ時の不具合があるため、あえてv8を使用
document.addEventListener('DOMContentLoaded', function () {

  // js-fade-slider
  if (document.querySelector('.js-fade-slider')) {
    const swiper = new Swiper('.js-fade-slider', {
      autoplay: {
        delay: 5000,    // スライド表示時間
      },
      loop: true,	// ループ表示
      effect: 'fade',	// スライド変化をフェードに設定
      speed: 2000,    // スライド変化時間
      allowTouchMove: false,   // スワイプでのスライド変更（初期値: true）
    });
  }

  // js-logo-slider
  if (document.querySelector('.js-logo-slider')) {

    const slider = document.querySelector('.js-logo-slider');
    const wrapper = slider.querySelector('.swiper-wrapper');
    const slides = wrapper.querySelectorAll('.swiper-slide');

    const originalCount = slides.length;
    const minSlidesNeeded = 8; // ループ安定用（PC4枚表示×2周分）

    if (originalCount < minSlidesNeeded) {
      const repeatTimes = Math.ceil(minSlidesNeeded / originalCount);

      for (let i = 0; i < repeatTimes - 1; i++) {
        slides.forEach(slide => {
          const clone = slide.cloneNode(true);
          wrapper.appendChild(clone);
        });
      }
    }

    new Swiper('.js-logo-slider', {
      loop: true,
      speed: 5000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      slidesPerView: 2.5,
      spaceBetween: 10,
      breakpoints: {
        569: {
          slidesPerView: 3,
          spaceBetween: 15
        },
        769: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      },
    });
  }


  // swiper サムネイルと連動するスライダー
  // サムネイル
  const swiper_thumb = new Swiper('.js-swiper-thumb', {
    slidesPerView: 3.2,
    freeMode: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    slideToClickedSlide: true,
    mousewheel: true,          // マウスホイール横移動
    grabCursor: true,

    scrollbar: {
      el: '.js-swiper-thumb .swiper-scrollbar',
      draggable: true,
      hide: false, // ← 常に表示
    },

    breakpoints: {
      769: {
        slidesPerView: 5.5,
      }
    },
  });

  const swiper_main = new Swiper('.js-swiper-main', {
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },

    slidesPerView: 1,
    loop: true,

    navigation: {
      nextEl: '.js-swiper-main .swiper-button-next',
      prevEl: '.js-swiper-main .swiper-button-prev',
    },

    thumbs: {
      swiper: swiper_thumb,
    },
  });

})